"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDPSSOMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class IDPSSOMapper {
    toDomain(result) {
        const accessToken = lodash_1.default.get(result, "data.idpSsoSignUp.accessToken");
        const expiresIn = lodash_1.default.get(result, "data.idpSsoSignUp.expiresIn");
        const refreshToken = lodash_1.default.get(result, "data.idpSsoSignUp.refreshToken");
        return {
            accessToken,
            expiresIn,
            refreshToken
        };
    }
}
exports.IDPSSOMapper = IDPSSOMapper;
